import type {
  ClubMessageDataRequest,
  ClubMessageDataResponse,
  HgClubMessageDataReply
} from '@ps/web-shared-api-types/v0/SwHomeGames';
import { useSelector } from 'react-redux';

import type { ErrorBody } from '@swf/core/errors/RequestError';
import useRequest from '@swf/core/hooks/useRequest';
import { select } from '@swf/core/store';
import { ENDPOINTS, handleServerError, handleServerResponse } from '@swf/poker';

import { ClubPlayerRole } from '../../../../types/common';
import type { FormFields } from '../Announcements';

interface Props {
  clubId: string;
  setLoading: (loading: boolean) => void;
}

const useClubMessageRequest = ({ clubId, setLoading }: Props) => {
  const request = useRequest();
  const userId = useSelector(select.account.getUserId);

  const handleSubmit = ({ announcement }: FormFields) => {
    setLoading(true);

    try {
      request({
        service: ENDPOINTS.clubMessageRequest,
        http: true,
        body: {
          clubMessageData: {
            clubMessageData: {
              type: 'HG_MESSAGE_TYPE_ANNOUNCEMENT',
              clubId: Number(clubId),
              content: announcement,
              userId,
              roleFlags: ClubPlayerRole.MEMBER,
              flags: 'REGULAR'
            }
          }
        } as ClubMessageDataRequest
      }).subscribe({
        next: ({ body }) => {
          handleServerResponse<ClubMessageDataResponse, HgClubMessageDataReply>({
            response: body,
            accessor: 'clubMessageDataReply'
          });

          setLoading(false);
        }
      });
    } catch (e) {
      handleServerError(e as ErrorBody);
      setLoading(false);
    }
  };

  return { handleSubmit };
};

export default useClubMessageRequest;
